export default __webpack_public_path__ + "static/media/flow.78dff311.png";